import { xingAppleTouchIconUrl, xingFaviconUrl } from '@xing-com/xing-logo';

export const DEFAULT_SEO_IMAGE = xingAppleTouchIconUrl;
export const DEFAULT_ICON = xingFaviconUrl;
export const DEFAULT_APPLE_ICON = xingAppleTouchIconUrl;
